'use strict';
import angular from 'angular';
import toastr from 'angular-toastr';
import {
  ToastrService
} from './toastr.service.js';

export default angular.module('georgeApp.toastr', [toastr])
  .config(['toastrConfig', function(toastrConfig) {
    angular.extend(toastrConfig, {
      positionClass: 'toast-top-left',
      timeOut: 3000,
      closeButton: true
    });
  }])
  .factory('ToastrSvc', ToastrService)
  .name;
